import React, { memo } from 'react'
import { BWPoweredByQb } from 'src/libs/qb-brand-web-components'

import logo from '../../../../assets/qbx-logo-dark.svg'

const PoweredByWrapper = () => <BWPoweredByQb qbxLogo={logo} />

export default memo(PoweredByWrapper)
